<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">ขอลาออก</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอลาออก
        </div>
      </div>
      <!-- Mobile -->
      <div class="col mb-2">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอลาออก
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            วัตถุประสงค์ที่ต้องการขอลาออก<span class="required">*</span>
          </div>
          <div class="ps-2 row font-family">
            <div>
              <input
                v-model="Memo"
                type="text"
                class="field field__input a-field__input"
                style="border-bottom: 1px solid #d0d0d0"
                autocomplete="off"
              />
            </div>
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="btn-next">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "ResignationView",
  components: {
    Menu,
    LoadingBs5,
  },
  data() {
    return {
      Loading: true,
      Memo: ''
    };
  },
  mounted() { 
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Loading = false;
      }
      else {
        this.Loading = false;
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      this.Loading = false; 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  methods: {
    EnterNext() {
      if(this.Memo.trim() === '' || this.Memo.trim() == null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุวัตถุประสงค์ที่ต้องการขอลาออก</label>',
        });
      }
      else {
        // SET INSERT DATA
        this.$store.state.RESIGN_MEMO.AGENTCODE = this.$store.state.AgentCode;
        this.$store.state.RESIGN_MEMO.REASON_DTL = this.Memo;

        this.$router.push('/FinishResignation');
      }
    },
  },
  
};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}
</style>